module.exports = __webpack_public_path__ + "static/media/high-quality.39ee2fe1.svg";